import { Outlet, createRootRoute } from '@tanstack/react-router'
import { AdminAuthProvider } from '../shared/auth/admin-auth-context'
import { Shell } from '../shared/ui/shell'

export const rootRoute = createRootRoute({
  component: () => (
    <AdminAuthProvider>
      <Shell>
        <Outlet />
      </Shell>
    </AdminAuthProvider>
  ),
})
